import script from "./ProductosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductosView.vue?vue&type=script&setup=true&lang=js"

import "./ProductosView.vue?vue&type=style&index=0&id=7f5fc2fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5fc2fb"]])

export default __exports__